/* ============================== */
/* assets/cart.js — refactored    */
/* ============================== */
if (window.__CART_JS_LOADED__) {
  console.warn('[cart.js] loaded twice — skipping second init');
} else {
  window.__CART_JS_LOADED__ = true;

/* ---------- Utilities ---------- */
function debounce(fn, t) {
  let id;
  return (...a) => { clearTimeout(id); id = setTimeout(() => fn.apply(this, a), t); };
}
function fetchConfig() {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'same-origin'
  };
}
function roundMoney(v) { return Math.round(v * 100) / 100; }
function sessionGet(k) { try { return sessionStorage.getItem(k); } catch { return null; } }
function sessionSet(k, v) { try { sessionStorage.setItem(k, v); } catch {} }
function sessionRemove(k) { try { sessionStorage.removeItem(k); } catch {} }

if (typeof CartPerformance === 'undefined') {
  window.CartPerformance = {
    measure: (name, callback) => callback(),
    measureFromEvent: () => {}
  };
}
/* ---------- Strings shim ---------- */
window.quickOrderListStrings = Object.assign({
  min_error: 'You must add at least [min].',
  max_error: 'Only [max] available.',
  step_error: 'Please add in multiples of [step].',
  quantityError: 'Quantity updated to [quantity].',
  error: 'Something went wrong.'
}, window.quickOrderListStrings || {});

window.cartStrings = Object.assign({
  min_error: 'You must add at least {min}.',
  max_error: 'Only {max} available.',
  step_error: 'Please add in multiples of {step}.',
  quantityError: 'Quantity updated to [quantity].',
  error: 'Something went wrong.'
}, window.cartStrings || {});


/* ====================================================== */
/* CACHED CART FETCH                                       */
/* ====================================================== */
let CART_LAST_JSON = null, CART_LAST_TS = 0;
let __cartFetchPromise = null;

async function getCartJSON(force = false) {
  const now = Date.now();
  if (!force && CART_LAST_JSON && now - CART_LAST_TS < 300) return CART_LAST_JSON;
  if (!force && __cartFetchPromise) return __cartFetchPromise;

  const request = fetch(`/cart.js?ts=${now}`, { cache: 'no-store', credentials: 'same-origin' })
    .then(r => r.json())
    .then(json => {
      CART_LAST_JSON = json;
      CART_LAST_TS = Date.now();
      return json;
    })
    .finally(() => { if (__cartFetchPromise === request) __cartFetchPromise = null; });

  __cartFetchPromise = request;
  return request;
}


/* ====================================================== */
/* CART RULES (free gifts + shipping protection)           */
/* ====================================================== */
function getSpVariantId() {
  return parseInt(document.getElementById('shipping-protection')?.dataset.variantId || '0', 10) || 0;
}

function isSpLine(item, spId = getSpVariantId()) {
  return !!spId && item.variant_id === spId;
}

function hasPaidItem(cart, spId = getSpVariantId()) {
  return (cart?.items || []).some(it => !isSpLine(it, spId) && (it.original_price || it.price) > 0);
}


/* ====================================================== */
/* GWP LINE INJECTION (single function, no MutationObs)    */
/* ====================================================== */
function getRewardVariantIds() {
  return Array.from(document.querySelectorAll('.milestone-detail[data-variant-id]'))
    .map(el => parseInt(el.dataset.variantId, 10))
    .filter(id => !isNaN(id) && id > 0);
}

function isFreeLine(item) {
  return item.price === 0 || item.final_line_price === 0;
}

function getLockedVariantIds(cart = CART_LAST_JSON) {
  const freeIds = (cart?.items || []).filter(isFreeLine).map(it => it.variant_id);
  return [...new Set([...getRewardVariantIds(), ...freeIds])];
}

function applyGwpLines(root = document) {
  const rewardIds = getLockedVariantIds();
  if (!rewardIds.length) return;

  root.querySelectorAll('tr[data-variant-id]').forEach(el => {
    const vid = parseInt(el.dataset.variantId, 10);
    const isGwp = rewardIds.includes(vid);
    el.classList.toggle('gwp-line', isGwp);
    if (isGwp) {
      const details = el.querySelector('.cart-item__details');
      if (details && !details.querySelector('.gwp-notice')) {
        const tag = document.createElement('span');
        tag.className = 'gwp-notice micro-text';
        tag.textContent = '1 Per Order';
        const qtyBlock = details.querySelector('.cart-item__quantity');
        if (qtyBlock) details.insertBefore(tag, qtyBlock);
        else details.appendChild(tag);
      }
    }
  });
}

/* Pre-inject GWP classes onto parsed HTML before DOM insertion */
function preInjectGwp(parsedDoc) {
  const rewardIds = getLockedVariantIds();
  if (!rewardIds.length) return;

  rewardIds.forEach(id => {
    const line = parsedDoc.querySelector(`tr[data-variant-id="${id}"]`);
    if (!line) return;
    line.classList.add('gwp-line');
    const details = line.querySelector('.cart-item__details');
    if (details && !details.querySelector('.gwp-notice')) {
      const notice = parsedDoc.createElement('span');
      notice.className = 'gwp-notice micro-text';
      notice.textContent = '1 Per Order';
      const qtyBlock = details.querySelector('.cart-item__quantity');
      if (qtyBlock) details.insertBefore(notice, qtyBlock);
      else details.appendChild(notice);
    }
  });
}


function updateCartCountBubble(count) {
  new Set(document.querySelectorAll('#cart-icon-bubble, .header__icon--cart')).forEach(link => {
    let bubble = link.querySelector('.cart-count-bubble');

    if (!count || count < 1) {
      if (bubble) bubble.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      link.appendChild(bubble);
    }

    const visible = bubble.querySelector('span[aria-hidden="true"]');
    const screenReader = bubble.querySelector('span.visually-hidden');
    if (visible) visible.textContent = count;
    if (screenReader) screenReader.textContent = `${count} ${count === 1 ? 'item' : 'items'}`;
  });
}

/* ====================================================== */
/* CHECKOUT BUTTON DISABLE HELPER                          */
/* ====================================================== */
function logCheckoutBlocked(reason, details = {}) {
  console.warn(`[checkout blocked] ${reason}`, details);
}

let checkoutLockCount = 0;
let checkoutLockLabel = null;

function getCheckoutLabelEl(btn) {
  return btn.querySelector('[data-checkout-label]')
    || Array.from(btn.querySelectorAll('span')).find(s => s.textContent.trim() && !s.children.length)
    || btn;
}

function paintCheckoutLock() {
  const locked = checkoutLockCount > 0;
  document.querySelectorAll(
    '.cart__checkout-button, #CartDrawer .cart__checkout-button, #main-cart-footer .cart__checkout-button'
  ).forEach(btn => {
    const labelEl = getCheckoutLabelEl(btn);
    const canLabel = labelEl !== btn || !btn.children.length;
    if (locked) {
      btn.disabled = true;
      btn.classList.add('is-disabled');
      if (checkoutLockLabel && canLabel) {
        if (!('originalLabel' in btn.dataset)) btn.dataset.originalLabel = labelEl.textContent;
        labelEl.textContent = checkoutLockLabel;
      }
    } else {
      btn.disabled = false;
      btn.classList.remove('is-disabled');
      if ('originalLabel' in btn.dataset) {
        labelEl.textContent = btn.dataset.originalLabel;
        delete btn.dataset.originalLabel;
      }
    }
  });
}

function toggleCheckoutDisabled(state, label = null) {
  checkoutLockCount = Math.max(0, checkoutLockCount + (state ? 1 : -1));
  console.log(`[checkout] lock ${state ? '+1' : '-1'} = ${checkoutLockCount}`, { label, rewardSyncLock: window.rewardSyncLock });
  if (state) {
    if (label) checkoutLockLabel = label;
    if (checkoutLockCount === 1) logCheckoutBlocked('Checkout disabled while cart updates', { label });
  } else if (!checkoutLockCount) {
    checkoutLockLabel = null;
  }
  paintCheckoutLock();
}

window.__checkoutState = () => ({
  lockCount: checkoutLockCount,
  rewardSyncLock: window.rewardSyncLock,
  proceeding: window.__checkoutProceeding
});


/* ====================================================== */
/* MILESTONE DESCRIPTIONS (pure DOM)                       */
/* ====================================================== */
function normalizeMilestoneDescriptions(cartTotal) {
  document.querySelectorAll('.milestone-detail').forEach(detail => {
    const heading = detail.dataset.heading || '';
    const threshold = parseFloat(detail.dataset.threshold || '0');
    const descEl = detail.querySelector('.milestone-description');
    if (!descEl) return;

    const remaining = threshold - cartTotal;
    descEl.innerHTML = remaining > 0
      ? `You're $<span class="left-over">${remaining.toFixed(2)}</span> away from ${heading}`
      : `You've unlocked ${heading}!`;
  });
}


/* ====================================================== */
/* MILESTONES CONTROLLER (pure DOM, no network calls)      */
/* ====================================================== */
window.__lastUnlockedMilestone = 0;

window.__MILESTONE_ANCHOR__ = document.querySelector('.milestones-bar') || null;
if (window.__MILESTONE_ANCHOR__) {
  window.__MILESTONE_ANCHOR__.dataset.milestoneAnchor = 'true';
}

function updateMilestones(cart) {
  const cartTotal = (cart?.total_price ? cart.total_price / 100 : 0);
  normalizeMilestoneDescriptions(cartTotal);

  const milestoneEls = document.querySelectorAll('.milestone-detail');
  if (!milestoneEls.length) return;

  const milestones = Array.from(milestoneEls).map(el => {
    const threshold = parseFloat(el.dataset.threshold) || 0;
    const idx = parseInt(
      [...el.classList].find(cls => /^milestone-\d+$/.test(cls))?.split('-')[1], 10
    ) || 0;
    const stepEl = document.querySelector(`.milestone-step.milestone-${idx}`);
    const stepIcon = stepEl?.querySelector('.milestone-icon') || null;
    return { el, threshold, idx, stepEl, stepIcon };
  });

  /* Toggle achieved/locked classes */
  milestones.forEach(m => {
    const achieved = cartTotal >= m.threshold;
    m.el.classList.toggle('milestone-achieved', achieved);
    m.el.classList.toggle('milestone-locked', !achieved);
    if (m.stepIcon) {
      m.stepIcon.classList.toggle('milestone-achieved', achieved);
      m.stepIcon.classList.toggle('milestone-locked', !achieved);
    }
  });

  /* Reorder by threshold */
  reorderMilestoneDetails();
  reorderMilestoneSteps();

  /* Flip animation for newly unlocked */
  const highestNow = milestones.reduce(
    (max, m) => (cartTotal >= m.threshold && m.idx > max ? m.idx : max), 0
  );
  milestones.forEach(m => {
    if (window.__lastUnlockedMilestone < m.idx && cartTotal >= m.threshold && m.stepIcon) {
      m.stepIcon.classList.add('flip');
      m.stepIcon.addEventListener('animationend', () => m.stepIcon.classList.remove('flip'), { once: true });
    }
  });
  window.__lastUnlockedMilestone = highestNow;

  /* Determine which milestone detail to show */
  const sorted = [...milestones].sort((a, b) => a.threshold - b.threshold);
  const unlocked = sorted.filter(m => cartTotal >= m.threshold);
  let visible;
  if (unlocked.length > 0) {
    const highestUnlocked = unlocked[unlocked.length - 1];
    const nextIndex = sorted.indexOf(highestUnlocked) + 1;
    visible = sorted[nextIndex] || highestUnlocked;
  } else {
    visible = sorted.find(m => cartTotal < m.threshold) || sorted[0];
  }

  milestones.forEach(m => {
    m.el.classList.toggle('is-visible', m === visible);
    m.el.style.display = (m === visible) ? 'flex' : 'none';
  });

  /* Connector positioning */
  if (visible) {
    const maxThreshold = Math.max(...milestones.map(m => m.threshold), 0) || 1;
    let pct = (visible.threshold / maxThreshold) * 100;
    pct = Math.min(95, Math.max(5, pct));
    visible.el.style.setProperty('--connector-left', `${pct}%`);
  }

  /* Step positioning */
  try {
    const steps = Array.from(document.querySelectorAll('.milestone-step'))
      .map(stepEl => {
        const idx = stepEl.className.match(/milestone-(\d+)/)?.[1];
        const threshold = parseFloat(
          document.querySelector(`.milestone-detail.milestone-${idx}`)?.dataset.threshold || '0'
        ) || 0;
        return { stepEl, threshold, idx };
      })
      .filter(m => m.threshold > 0);

    if (steps.length) {
      const maxThreshold = Math.max(...steps.map(m => m.threshold));
      steps.forEach((m, index) => {
        const isLast = index === steps.length - 1;
        let pct = (m.threshold / maxThreshold) * 100;
        const EDGE_PAD = 10;
        const PIXEL_OFFSET = -10;
        pct = Math.max(EDGE_PAD, pct);
        pct = isLast ? Math.min(110, pct) : Math.min(100 - EDGE_PAD, pct);

        const finalLeft = `calc(${pct}% + ${PIXEL_OFFSET}px)`;
        m.stepEl.style.position = 'absolute';
        m.stepEl.style.left = finalLeft;
        m.stepEl.style.transform = 'translateX(-50%)';
        m.stepEl.style.setProperty('--milestone-left', finalLeft);

        const detailEl = document.querySelector(`.milestone-detail.milestone-${m.idx}`);
        if (detailEl) detailEl.style.setProperty('--milestone-left', finalLeft);
      });
    }
  } catch (e) {
    console.warn('[milestones] step positioning failed', e);
  }

  /* Progress bar */
  const thresholds = milestones.map(m => m.threshold).sort((a, b) => a - b);
  const maxThreshold = thresholds[thresholds.length - 1] || 1;
  const pct = Math.max(0, Math.min(100, Math.round((cartTotal / maxThreshold) * 100)));
  const progressRoot = document.querySelector('.progress-bar-wrapper');
  if (progressRoot) {
    const fill = progressRoot.querySelector('.progress-bar-fill');
    if (fill) fill.style.width = `${pct}%`;
    const label = progressRoot.querySelector('[data-progress-label]');
    if (label) label.textContent = `${pct}%`;
  }

  /* Reward milestone achieved state from cart contents */
  try {
    const cartVariantIds = cart.items.map(item => item.variant_id);
    document.querySelectorAll('.milestone-detail[data-variant-id]').forEach(el => {
      const variantId = parseInt(el.dataset.variantId, 10);
      const inCart = cartVariantIds.includes(variantId);
      el.classList.toggle('milestone-achieved', inCart);
      el.classList.toggle('milestone-locked', !inCart);
    });
  } catch (e) {}
}

window.__updateMilestones = updateMilestones;

function reorderMilestoneDetails() {
  const wrap = document.querySelector('.milestone-details');
  if (!wrap) return;
  const items = Array.from(wrap.querySelectorAll('.milestone-detail'));
  if (!items.length) return;
  items.sort((a, b) => (parseFloat(a.dataset.threshold) || 0) - (parseFloat(b.dataset.threshold) || 0));
  items.forEach(el => wrap.appendChild(el));
}
window.reorderMilestoneDetails = reorderMilestoneDetails;

function reorderMilestoneSteps() {
  const wrap = document.querySelector('.milestone-steps');
  if (!wrap) return;
  const items = Array.from(wrap.querySelectorAll('.milestone-step'));
  items.sort((a, b) => {
    const idxA = a.className.match(/milestone-(\d+)/)?.[1];
    const idxB = b.className.match(/milestone-(\d+)/)?.[1];
    const ta = parseFloat(document.querySelector(`.milestone-detail.milestone-${idxA}`)?.dataset.threshold || '0') || 0;
    const tb = parseFloat(document.querySelector(`.milestone-detail.milestone-${idxB}`)?.dataset.threshold || '0') || 0;
    return ta - tb;
  });
  items.forEach(el => wrap.appendChild(el));
}
window.reorderMilestoneSteps = reorderMilestoneSteps;


/* ====================================================== */
/* SYNC MILESTONE REWARDS (batched, non-recursive)         */
/* ====================================================== */
/*
 * This is the ONLY function that adds/removes reward variants.
 * It runs ONCE per user action. It NEVER re-triggers itself.
 * If it makes changes it calls refreshDrawer once, which does
 * NOT call syncMilestoneRewards back.
 */
if (window.rewardSyncLock == null) window.rewardSyncLock = false;
async function syncMilestoneRewards(cart) {
  if (!cart?.items || window.rewardSyncLock) return;
  window.rewardSyncLock = true;
  toggleCheckoutDisabled(true, 'Updating…');

  let madeChanges = false;

  try {
    const ALLOW_STACKING = window.__ALLOW_MILESTONE_STACKING__ === true;
    const cartTotal = cart.total_price / 100;
    const spId = getSpVariantId();
    const paid = hasPaidItem(cart, spId);
    const presentIds = cart.items.map(it => it.variant_id);

    const allRewards = Array.from(document.querySelectorAll('.milestone-detail[data-variant-id]')).map(el => ({
      threshold: parseFloat(el.dataset.threshold) || 0,
      variantId: parseInt(el.dataset.variantId, 10),
      noProduct: el.dataset.noproduct === 'true'
    })).filter(r => r.variantId > 0 && !r.noProduct);

    const reachedRewards = paid ? allRewards.filter(r => cartTotal >= r.threshold) : [];
    const highestReachedThreshold = reachedRewards.length
      ? Math.max(...reachedRewards.map(r => r.threshold))
      : 0;

    const updates = {};
    const adds = [];

    for (const reward of allRewards) {
      const { threshold, variantId } = reward;
      const reached = paid && cartTotal >= threshold;
      const inCart = presentIds.includes(variantId);
      const item = cart.items.find(it => it.variant_id === variantId);

      if (inCart && item && item.quantity > 1) updates[variantId] = 1;

      if (reached && !inCart) {
        if (ALLOW_STACKING || threshold === highestReachedThreshold) adds.push(variantId);
        continue;
      }

      if (!reached && inCart) {
        updates[variantId] = 0;
        continue;
      }

      if (!ALLOW_STACKING && inCart && reached && threshold !== highestReachedThreshold) {
        updates[variantId] = 0;
      }
    }

    const seenFree = new Set();
    cart.items.forEach(it => {
      if (!isFreeLine(it) || isSpLine(it, spId)) return;
      if (!paid) {
        updates[it.key] = 0;
        return;
      }
      if (updates[it.variant_id] !== undefined) return;
      if (seenFree.has(it.variant_id)) {
        updates[it.key] = 0;
        return;
      }
      seenFree.add(it.variant_id);
      if (it.quantity > 1) updates[it.key] = 1;
    });

    const spLines = cart.items.filter(it => isSpLine(it, spId));
    if (spLines.length) {
      if (!paid) {
        spLines.forEach(it => { updates[it.key] = 0; });
        sessionRemove('sp_auto_added');
      } else {
        spLines.forEach((it, i) => {
          if (i > 0) updates[it.key] = 0;
          else if (it.quantity > 1) updates[it.key] = 1;
        });
      }
    }

    if (Object.keys(updates).length || adds.length) {
      console.log('[syncRewards] changes', { updates, adds });
    }

    let prefetched = null;

    if (Object.keys(updates).length) {
      madeChanges = true;

      const removedKeys = new Set(Object.keys(updates).filter(k => updates[k] === 0));
      document.querySelectorAll('tr.cart-item[data-variant-id]').forEach(row => {
        if (removedKeys.has(row.dataset.variantId) || removedKeys.has(row.dataset.key)) smoothCollapse(row);
      });

      const res = await fetch(`/cart/update.js?ts=${Date.now()}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates, sections: 'cart-drawer' })
      });
      const data = await res.json();

      if (!adds.length && data?.items && data?.sections?.['cart-drawer']) {
        CART_LAST_JSON = data;
        CART_LAST_TS = Date.now();
        prefetched = { cart: data, section: data.sections['cart-drawer'] };
      }
    }

    if (adds.length) {
      madeChanges = true;
      await fetch(`/cart/add.js?ts=${Date.now()}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: adds.map(id => ({ id, quantity: 1 })) })
      });
    }

    if (madeChanges) await refreshDrawer(prefetched);
  } catch (err) {
    console.warn('[syncRewards] failed', err);
    try { await refreshDrawer(); } catch {}
  } finally {
    toggleCheckoutDisabled(false);
    window.rewardSyncLock = false;
  }
}


/* ====================================================== */
/* DRAWER REFRESH (no reward sync, no recursive hooks)     */
/* ====================================================== */
const sharedParser = () => window.__sharedDOMParser || (window.__sharedDOMParser = new DOMParser());
async function refreshDrawer(prefetched) {
  let html;
  let cart;

  if (prefetched?.section && prefetched?.cart) {
    html = { 'cart-drawer': prefetched.section };
    cart = prefetched.cart;
  } else {
    try {
      const [res, freshCart] = await Promise.all([
        fetch('/?sections=cart-drawer', { credentials: 'same-origin', cache: 'no-store' }),
        getCartJSON(true).catch(() => null)
      ]);
      html = await res.json();
      cart = freshCart;
    } catch (err) {
      console.error('[CartDrawer] section fetch failed', err);
      return null;
    }
  }

  const doc = sharedParser().parseFromString(html['cart-drawer'], 'text/html');

  const srcHeader = doc.querySelector('.drawer__header');
  const dstHeader = document.querySelector('.drawer__header');
  if (srcHeader && dstHeader) {
    const incomingMilestones = srcHeader.querySelector('.milestones-bar');
    if (incomingMilestones) incomingMilestones.remove();
    dstHeader.replaceWith(srcHeader);
    const newHeader = document.querySelector('.drawer__header');
    const anchor = window.__MILESTONE_ANCHOR__;
    if (anchor && newHeader && !newHeader.contains(anchor)) newHeader.appendChild(anchor);
  }

  const srcItems = doc.querySelector('cart-drawer-items');
  const dstItems = document.querySelector('cart-drawer-items');
  if (srcItems && dstItems) {
    preInjectGwp(doc);
    dstItems.replaceWith(srcItems);
  }

  const srcFooter = doc.querySelector('.drawer__footer');
  const dstFooter = document.querySelector('.drawer__footer');
  if (srcFooter && dstFooter) {
    dstFooter.replaceWith(srcFooter);
    paintCheckoutLock();
  }

  const form = document.querySelector('#CartDrawer-Form');
  if (form) {
    form.setAttribute('action', '/cart');
    form.setAttribute('method', 'post');
    form.setAttribute('novalidate', 'true');
    if (!form.querySelector('input[name="checkout"]')) {
      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'checkout';
      hidden.value = 'Checkout';
      form.appendChild(hidden);
    }
  }

  const srcEmpty = doc.querySelector('.drawer__inner-empty');
  const dstEmpty = document.querySelector('.drawer__inner-empty');
  if (srcEmpty && dstEmpty) dstEmpty.replaceWith(srcEmpty);
  else if (srcEmpty && !dstEmpty) document.querySelector('#CartDrawer .drawer__inner')?.appendChild(srcEmpty);
  else if (!srcEmpty && dstEmpty) dstEmpty.remove();

  const hasItems = !!(cart?.items?.length);
  if (cart) updateCartCountBubble(cart.item_count);
  document.querySelector('cart-drawer')?.classList.toggle('is-empty', !hasItems);
  document.querySelector('cart-drawer-items')?.classList.toggle('is-empty', !hasItems);

  if (cart) {
    document.querySelectorAll('.milestone-detail').forEach(el => {
      const h3 = el.querySelector('h3');
      if (h3) el.dataset.heading = h3.textContent.trim();
    });
    updateMilestones(cart);
  }

  try {
    const collectionEl = document.querySelector('.cart-drawer__collection');
    if (collectionEl) collectionEl.classList.toggle('hidden', !hasItems);
    if (hasItems) {
      const inner = document.querySelector('#CartDrawer .drawer__inner');
      if (!inner?.querySelector('.cart-view') && doc.querySelector('.cart-view')) {
        inner?.appendChild(doc.querySelector('.cart-view'));
      }
      requestAnimationFrame(() => reInitCartSwiper('drawer-refresh'));
    }
  } catch {}

  applyInventoryGuards(document);
  applyGwpLines();
  guardDrawerQuickAddButtons();
  rebindCartDrawerAccordions();
  syncShippingProtectionToggle();

  try {
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'drawer-refresh', cartData: cart });
    }
  } catch {}

  return cart;
}

/* ====================================================== */
/* POST-RENDER PIPELINE (lightweight, no reward sync)      */
/* ====================================================== */
function runPostRenderHooks(cart) {
  const idle = window.requestIdleCallback || (fn => setTimeout(fn, 40));
  idle(() => {
    applyInventoryGuards(document);
    if (cart) updateMilestones(cart);
    applyGwpLines();
  });
  idle(() => {
    syncShippingProtectionToggle();
    guardDrawerQuickAddButtons();
    reInitCartSwiper('post-render');
  });
}


/* ====================================================== */
/* SMOOTH COLLAPSE + REMOVE BUTTON                         */
/* ====================================================== */
function smoothCollapse(el) {
  if (!el) return;
  const h = el.getBoundingClientRect().height;
  el.style.cssText = `box-sizing:border-box;height:${h}px;transition:height .25s ease,opacity .25s ease,margin .25s ease,padding .25s ease;overflow:hidden;`;
  void el.offsetHeight;
  el.style.cssText += 'opacity:0;margin:0;padding:0;height:0;';
}

(() => {
  if (!window.CartRemoveButton) {
    window.CartRemoveButton = class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          event.preventDefault();
          const index = this.dataset.index;
          if (!index) return;
          const host = this.closest('cart-items') || this.closest('cart-drawer-items');
          const row = document.getElementById(`CartItem-${index}`)
            || document.getElementById(`CartDrawer-Item-${index}`)
            || this.closest('tr.cart-item');
          if (row?.isConnected) smoothCollapse(row);
          /* Reduced from 150ms to 50ms — animation already started */
          setTimeout(() => {
            if (host?.updateQuantity) host.updateQuantity(index, 0, event, 'line');
          }, 50);
        });
      }
    };
  }
  if (!customElements.get('cart-remove-button')) {
    customElements.define('cart-remove-button', window.CartRemoveButton);
  }
})();

/* Remove animation CSS */
(() => {
  if (document.getElementById('cart-remove-anim-css')) return;
  const style = document.createElement('style');
  style.id = 'cart-remove-anim-css';
  style.textContent = 'tr.cart-item{will-change:height,opacity,margin,padding}';
  document.head.appendChild(style);
})();


/* ====================================================== */
/* INVENTORY GUARDS                                        */
/* ====================================================== */
(function () {
  function readMaxFromDOM(input) {
    if (parseInt(input.dataset.quantityVariantId || '0', 10) === getSpVariantId()) return 1;
    const managed = String(input.dataset.variantManaged || '').toLowerCase() === 'true';
    const policy = (input.dataset.variantPolicy || '').toLowerCase();
    const rawMax = parseInt(input.dataset.variantMax ?? '', 10);
    if (managed && policy !== 'continue' && Number.isFinite(rawMax)) return Math.max(0, rawMax);
    return Infinity;
  }

  function guardOneInput(input) {
    const wrap = input.closest('.quantity');
    if (!wrap) return;
    const minus = wrap.querySelector('button[name="minus"]');
    const plus = wrap.querySelector('button[name="plus"]');
    const qty = parseInt(input.value || input.getAttribute('value') || '1', 10) || 1;
    const max = readMaxFromDOM(input);
    if (Number.isFinite(max)) input.max = String(max); else input.removeAttribute('max');
    if (minus) minus.disabled = (qty <= 0);
    if (plus) plus.disabled = (qty >= max);
  }

  window.applyInventoryGuards = function (root = document) {
    const inputs = root.querySelectorAll('input.quantity__input[data-quantity-variant-id]');
    inputs.forEach(input => {
      guardOneInput(input);
      if (!input.__hasGuardListener) {
        input.addEventListener('input', () => guardOneInput(input), { passive: true });
        input.__hasGuardListener = true;
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => applyInventoryGuards());
  else applyInventoryGuards();
})();


/* ====================================================== */
/* QUICK ADD HELPERS                                       */
/* ====================================================== */
const QA_INV_CACHE = { variant: new Map() };

async function fetchVariantJSON(variantId) {
  if (QA_INV_CACHE.variant.has(variantId)) return QA_INV_CACHE.variant.get(variantId);
  const r = await fetch(`/variants/${variantId}.json`, { credentials: 'same-origin' });
  if (!r.ok) return null;
  const j = await r.json();
  QA_INV_CACHE.variant.set(variantId, j?.variant || null);
  return j?.variant || null;
}

function computeVariantMax(variant) {
  if (!variant) return Infinity;
  const managed = !!variant.inventory_management;
  const deny = (variant.inventory_policy === 'deny');
  const qty = Number.isFinite(variant.inventory_quantity) ? Math.max(0, variant.inventory_quantity) : 0;
  return (managed && deny) ? qty : Infinity;
}

async function preflightAdd(variantId, requestedQty) {
  const [variant, cart] = await Promise.all([fetchVariantJSON(variantId), getCartJSON()]);
  const max = computeVariantMax(variant);
  const inCart = (cart.items || []).reduce((sum, it) =>
    sum + (String(it.variant_id) === String(variantId) ? it.quantity : 0), 0);
  const remaining = Number.isFinite(max) ? Math.max(0, max - inCart) : Infinity;
  const allowed = Number.isFinite(remaining) ? Math.min(requestedQty, remaining) : requestedQty;
  return { allowed, remaining, max, inCart };
}

function afterBlockedAdd(btn) {
  if (!btn) return;
  btn.disabled = true;
  btn.classList.add('is-disabled');
  setTimeout(() => { btn.disabled = false; btn.classList.remove('is-disabled'); }, 400);
}

function openDrawer() {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  try { drawer.open(); } catch (_) {}
  document.head.insertAdjacentHTML('beforeend', '<style>.drawer.active{visibility:visible}</style>');
}


/* ====================================================== */
/* ACCORDION REBIND                                        */
/* ====================================================== */
window.__cartCollectionOpen = sessionGet('cart_collection_open') === 'true';

function rebindCartDrawerAccordions(retry = 0) {
  if (!document.querySelector('.cart-drawer__collection')) return;
  const header = document.querySelector('.cart-drawer__collection-header');
  const body = document.querySelector('.cart-drawer__collection-body');
  const wrap = document.querySelector('.cart-header-wrapper');
  if (!header || !body) {
    if (retry < 10) setTimeout(() => rebindCartDrawerAccordions(retry + 1), 150);
    return;
  }

  header.replaceWith(header.cloneNode(true));
  const newHeader = document.querySelector('.cart-drawer__collection-header');
  const isOpen = window.__cartCollectionOpen === true;

  body.classList.toggle('open', isOpen);
  newHeader.classList.toggle('active', !isOpen);
  wrap?.classList.toggle('active', !isOpen);

  newHeader.addEventListener('click', (e) => {
    e.preventDefault();
    const bodyNow = document.querySelector('.cart-drawer__collection-body');
    if (!bodyNow) return;
    const nowOpen = !bodyNow.classList.contains('open');
    bodyNow.classList.toggle('open', nowOpen);
    newHeader.classList.toggle('active', !nowOpen);
    wrap?.classList.toggle('active', !nowOpen);
    window.__cartCollectionOpen = nowOpen;
    sessionSet('cart_collection_open', nowOpen ? 'true' : 'false');
  });
}
window.rebindCartDrawerAccordions = rebindCartDrawerAccordions;


/* ====================================================== */
/* DRAWER QUICK ADD GUARD                                  */
/* ====================================================== */
window.guardDrawerQuickAddButtons = async function () {
  const btns = Array.from(document.querySelectorAll('#CartDrawer .quick-add-btn, cart-drawer .quick-add-btn'));
  if (!btns.length) return;

  const cart = await getCartJSON();
  const ids = [...new Set(btns.map(b => parseInt(b.getAttribute('data-variant-id') || '0', 10)).filter(Boolean))];
  const variants = await Promise.all(ids.map(id => fetchVariantJSON(id)));
  const vById = new Map();
  variants.forEach(v => { if (v) vById.set(v.id, v); });

  btns.forEach(btn => {
    const id = parseInt(btn.getAttribute('data-variant-id') || '0', 10);
    const req = parseInt(btn.getAttribute('data-quantity') || '1', 10) || 1;
    const v = vById.get(id);
    let allowed = req;
    if (v) {
      const max = computeVariantMax(v);
      const inCart = (cart.items || []).reduce((s, it) => s + (String(it.variant_id) === String(id) ? it.quantity : 0), 0);
      const remaining = Number.isFinite(max) ? Math.max(0, max - inCart) : Infinity;
      allowed = Number.isFinite(remaining) ? Math.min(req, remaining) : req;
    }
    btn.disabled = allowed <= 0;
    btn.classList.toggle('is-disabled', allowed <= 0);
    if (allowed <= 0) btn.setAttribute('aria-disabled', 'true');
    else btn.removeAttribute('aria-disabled');
  });
};


/* ====================================================== */
/* DRAWER QUICK ADD CLICK HANDLER                          */
/* ====================================================== */
document.addEventListener('click', async function (e) {
  const btn = e.target.closest('#CartDrawer .quick-add-btn, cart-drawer .quick-add-btn');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  if (!btn.getAttribute('type')) btn.setAttribute('type', 'button');

  const id = parseInt(btn.getAttribute('data-variant-id') || '0', 10);
  const req = parseInt(btn.getAttribute('data-quantity') || '1', 10) || 1;
  if (!id) return;

  let allowed = req;
  try { allowed = (await preflightAdd(id, req)).allowed; } catch (_) {}
  if (allowed <= 0) { afterBlockedAdd(btn); return; }

  const labelEl = btn.querySelector('[data-label]') || btn.querySelector('.label') || btn;
  const prevTxt = (labelEl.textContent || '').trim();
  labelEl.textContent = 'Adding…';
  btn.disabled = true;
  btn.classList.add('is-loading');

  try {
    const r = await fetch(`/cart/add.js?ts=${Date.now()}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id, quantity: allowed }),
      credentials: 'same-origin'
    });
    if (!r.ok) throw await r.json();
    const postCart = (await refreshDrawer()) || (await getCartJSON(true));
    await syncMilestoneRewards(postCart);
    openDrawer();
    try { publish?.(PUB_SUB_EVENTS?.cartUpdate, { source: 'drawer-quick-add' }); } catch (_) {}
  } catch (err) {
    console.error('[DRAWER QUICK-ADD] failed', err);
    alert(err?.description || 'Could not add to cart.');
  } finally {
    labelEl.textContent = prevTxt || 'Add to Cart';
    btn.disabled = false;
    btn.classList.remove('is-loading');
  }
});


/* ====================================================== */
/* CART ITEMS COMPONENT                                    */
/* ====================================================== */
let cartUpdateInflight = false;

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => this.onChange(event), ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener('change', debouncedOnChange.bind(this));

    /* Global +/- handler (once) */
    if (!window.__BIND_PM_CAPTURE__) {
      window.__BIND_PM_CAPTURE__ = true;

      document.addEventListener('click', function (e) {
        const btn = e.target.closest('button[name="plus"], button[name="minus"]');
        if (!btn) return;
        const host = btn.closest('cart-items, cart-drawer-items');
        if (!host?.updateQuantity) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const wrap = btn.closest('.quantity');
        const input = wrap?.querySelector('.quantity__input') || wrap?.querySelector('input[name="updates[]"]');
        if (!input) return;
        const line = input.dataset.index;

        /* GWP hard lock */
        const row = btn.closest('tr.cart-item');
        if (row?.classList.contains('gwp-line')) {
          input.value = '1';
          input.setAttribute('value', '1');
          input.dataset.skipNextChange = '1';
          const minus = wrap.querySelector('button[name="minus"]');
          const plus = wrap.querySelector('button[name="plus"]');
          if (minus) minus.disabled = true;
          if (plus) plus.disabled = true;
          return;
        }

        const isSpRow = parseInt(input.dataset.quantityVariantId || row?.dataset.variantId || '0', 10) === getSpVariantId();
        if (isSpRow && btn.name === 'plus') {
          btn.disabled = true;
          return;
        }

        const step = parseInt(input.step || '1', 10) || 1;
        const min = parseInt(input.min || input.dataset.min || '1', 10) || 1;
        const rawMax = parseInt(input.max ?? '', 10);
        const max = isSpRow ? 1 : (Number.isFinite(rawMax) ? rawMax : Infinity);
        const curLive = parseInt(input.value || '0', 10);
        const curAttr = parseInt(input.getAttribute('value') || '0', 10);
        const current = (Number.isFinite(curLive) && curLive > 0) ? curLive
          : (Number.isFinite(curAttr) && curAttr > 0) ? curAttr : min;

        const next = btn.name === 'plus'
          ? Math.min(current + step, max)
          : Math.max(0, current - step);

        input.value = String(next);
        input.setAttribute('value', String(next));
        input.dataset.skipNextChange = '1';
        host.updateQuantity(String(line), next, e, input.getAttribute('name'), input.dataset.quantityVariantId);
      }, true);
    }
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') return;
      if (event.source === 'drawer-refresh' && this.tagName === 'CART-DRAWER-ITEMS') return;
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() { this.cartUpdateUnsubscriber?.(); }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    if (input) input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    if (event?.type === 'change' && event.target?.dataset?.skipNextChange === '1') {
      delete event.target.dataset.skipNextChange;
      return;
    }
    const tgt = event.target;
    const idx = tgt.dataset.index;
    const isSp = parseInt(tgt.dataset.quantityVariantId || '0', 10) === getSpVariantId();
    const isGwp = !!tgt.closest('tr.gwp-line');
    const min = parseInt(tgt.dataset.min || tgt.getAttribute('min') || '1', 10) || 1;
    const max = (isSp || isGwp) ? 1 : parseInt(tgt.max ?? '', 10);
    const step = parseInt(tgt.step || '1', 10) || 1;

    let val = parseInt(tgt.value, 10);
    if (!Number.isFinite(val)) val = min;
    if ((isSp || isGwp) && val > 1) {
      val = 1;
      tgt.value = '1';
    }

    let message = '';
    if (val < min && val !== 0) message = window.quickOrderListStrings.min_error.replace('[min]', min);
    else if (Number.isFinite(max) && val > max) message = window.quickOrderListStrings.max_error.replace('[max]', max);
    else if (val !== 0 && (val - min) % step !== 0) message = window.quickOrderListStrings.step_error.replace('[step]', step);

    if (message) {
      this.setValidity(event, idx, message);
    } else {
      tgt.setCustomValidity('');
      tgt.reportValidity();
      this.updateQuantity(idx, val, event, document.activeElement.getAttribute('name'), tgt.dataset.quantityVariantId);
    }
  }

  onChange(event) { this.validateQuantity(event); }

  onCartUpdate() {
    const isDrawer = this.tagName === 'CART-DRAWER-ITEMS';
    const url = isDrawer
      ? `${routes.cart_url}?section_id=cart-drawer`
      : `${routes.cart_url}?section_id=main-cart-items`;

    return fetch(url)
      .then(r => r.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (isDrawer) {
          preInjectGwp(html);
          ['cart-drawer-items', '.cart-drawer__footer'].forEach(sel => {
            const target = document.querySelector(sel);
            const source = html.querySelector(sel);
            if (target && source) target.replaceWith(source);
          });
          paintCheckoutLock();
          applyInventoryGuards(document);
          const idle = window.requestIdleCallback || (fn => setTimeout(fn, 80));
          idle(() => {
            reInitCartSwiper('drawer-refresh');
            guardDrawerQuickAddButtons();
            rebindCartDrawerAccordions();
          });
        } else {
          const sourceQty = html.querySelector('cart-items');
          if (sourceQty) this.innerHTML = sourceQty.innerHTML;
          applyInventoryGuards(document);
        }
      })
      .catch(console.error);
  }

  getSectionsToRender() {
    const sections = [];
    const mainItemsEl = document.getElementById('main-cart-items');
    const mainFooterEl = document.getElementById('main-cart-footer');
    if (mainItemsEl?.dataset?.id) sections.push({ id: 'main-cart-items', section: mainItemsEl.dataset.id, selector: '.js-contents' });
    if (mainFooterEl?.dataset?.id) sections.push({ id: 'main-cart-footer', section: mainFooterEl.dataset.id, selector: '.js-contents' });
    sections.push(
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '#cart-icon-bubble' },
      { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
      { id: 'cart-drawer', section: 'cart-drawer', selector: '.shopify-section' }
    );
    return sections;
  }

  /* ==========================================================
     updateQuantity — single action, then reward sync
     ========================================================== */
  updateQuantity(line, quantity, event, name, variantId) {
    if (cartUpdateInflight) return;
    cartUpdateInflight = true;
    toggleCheckoutDisabled(true, 'Updating…');
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(s => s.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event?.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
      .then(r => r.text())
      .then(async (state) => {
        let parsedState;
        try { parsedState = JSON.parse(state); } catch {
          console.warn('[updateQuantity] non-JSON response', String(state).slice(0, 200));
          await refreshDrawer();
          await syncMilestoneRewards(await getCartJSON(true));
          return;
        }
        if (!parsedState) { this.disableLoading(line); return; }
        if (!parsedState.errors) {
          CART_LAST_JSON = parsedState;
          CART_LAST_TS = Date.now();
        }

        CartPerformance.measure(`${eventTarget}:paint-updated-sections`, () => {
          const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            if (quantityElement) quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          /* Empty state toggles */
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
          updateCartCountBubble(parsedState.item_count);

          /* Section patches with GWP pre-injection */
          const parser = sharedParser();
          this.getSectionsToRender().forEach(section => {
            const target = document.getElementById(section.id);
            if (!target) return;
            const html = parsedState.sections[section.section];
            if (!html) return;

            /* Cart icon bubble: only update the count, don't replace the whole element
               (the server section template doesn't have the custom "Cart" text span) */
            if (section.id === 'cart-icon-bubble') {
              updateCartCountBubble(parsedState.item_count);
              return;
            }
            const tempDoc = parser.parseFromString(html, 'text/html');
            preInjectGwp(tempDoc);
            const newHTML = tempDoc.querySelector(section.selector)?.innerHTML || '';
            const elementToReplace = target.querySelector(section.selector) || target;
            elementToReplace.innerHTML = newHTML;
          });
          paintCheckoutLock();

          try {
            const liveEl = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
            if (liveEl) liveEl.setAttribute('value', String(liveEl.value));
          } catch (_) {}

          /* Accessibility */
          const updatedValue = parsedState.items[line - 1]?.quantity;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement?.value || 'NaN', 10)) {
            message = typeof updatedValue === 'undefined'
              ? window.cartStrings.error
              : window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
          this.updateLiveRegions(line, message);

          /* Focus management */
          const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          const fallbackTarget = document.querySelector('.cart-item__name');
          try {
            if (lineItem?.querySelector?.(`[name="${name}"]`)) {
              const input = lineItem.querySelector(`[name="${name}"]`);
              cartDrawerWrapper ? trapFocus(cartDrawerWrapper, input) : input.focus();
            } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
              const emptyWrapper = cartDrawerWrapper.querySelector('.drawer__inner-empty');
              const emptyLink = emptyWrapper?.querySelector('a');
              if (emptyWrapper && emptyLink) trapFocus(emptyWrapper, emptyLink);
            } else if (fallbackTarget && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper, fallbackTarget);
            }
          } catch {}

          /* Post-render (no reward sync here, that happens below) */
          applyInventoryGuards(document);
          updateMilestones(parsedState);
          applyGwpLines();
          syncShippingProtectionToggle();
          guardDrawerQuickAddButtons();
          reInitCartSwiper('post-render');
          rebindCartDrawerAccordions();

          /* Publish */
          try {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId });
          } catch {}
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        /* Reward sync AFTER DOM is patched (single pass, no recursion) */
        try { await syncMilestoneRewards(parsedState); } catch {}
      })
      .catch(async (err) => {
        console.error('[updateQuantity] failed', err);
        try {
          await refreshDrawer();
          await syncMilestoneRewards(await getCartJSON(true));
        } catch {}
      })
      .finally(() => {
        this.disableLoading(line);
        cartUpdateInflight = false;
        toggleCheckoutDisabled(false);
        rebindCartDrawerAccordions();
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;
    this.lineItemStatusElement?.setAttribute('aria-hidden', true);
    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus?.setAttribute('aria-hidden', false);
    setTimeout(() => cartStatus?.setAttribute('aria-hidden', true), 1000);
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');
    [...this.querySelectorAll(`#CartItem-${line} .loading__spinner`),
     ...this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`)]
      .forEach(o => o.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement?.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');
    [...this.querySelectorAll(`#CartItem-${line} .loading__spinner`),
     ...this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`)]
      .forEach(o => o.classList.add('hidden'));
  }
}

window.CartItems = CartItems;
if (!customElements.get('cart-items')) customElements.define('cart-items', CartItems);
window.dispatchEvent(new Event('CartItems:ready'));

if (!customElements.get('cart-note')) {
  customElements.define('cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('input', debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body })
            .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
        }, ON_CHANGE_DEBOUNCE_TIMER));
      }
    }
  );
}


/* ====================================================== */
/* DEBOUNCED CART REFRESH FALLBACK                         */
/* ====================================================== */
if (!window.debouncedRefreshCartSections) {
  window.debouncedRefreshCartSections = debounce(async () => {
    try { await refreshDrawer(); } catch (err) { console.warn('[cart.js] debounced refresh failed', err); }
  }, 300);
}


/* ====================================================== */
/* DRAWER SWIPER INIT                                      */
/* ====================================================== */
window.reInitCartSwiper = function reInitCartSwiper(source = 'unknown') {
  if (!window.__UPSellsEnabled__) return;
  const el = document.querySelector('#CartDrawer .cart-view') || document.querySelector('cart-drawer .cart-view');
  if (!el || typeof window.Swiper !== 'function') return;
  const wrapper = el.querySelector('.swiper-wrapper');
  const slides = el.querySelectorAll('.swiper-slide');
  if (!wrapper || !slides.length) return;

  if (el.__swiper?.destroy) {
    try { el.__swiper.destroy(true, true); } catch {}
  }
  try {
    el.__swiper = new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 5,
      autoplay: { delay: 6000, disableOnInteraction: false },
      observer: true,
      observeParents: true,
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 5 },
        1200: { slidesPerView: 1, spaceBetween: 5 }
      }
    });
    requestAnimationFrame(() => el.__swiper.update());
  } catch (err) {
    console.error('[swiper] init failed:', err);
  }
};


/* ====================================================== */
/* QUICK ADD FORM HANDLER                                  */
/* ====================================================== */
(function () {
  if (window.__addToCartBound) return;
  window.__addToCartBound = true;

  document.addEventListener('submit', async (ev) => {
    const form = ev.target.closest('form[data-type="quick-add-form"], form[data-type="add-to-cart-form"]');
    if (!form) return;
    ev.preventDefault();

    const btn = form.querySelector('button[type="submit"]');
    if (btn?.disabled) return;

    const label = btn?.querySelector('span') || btn;
    if (label && !label.dataset.originalText) label.dataset.originalText = label.textContent.trim();
    if (label) label.textContent = 'Adding...';
    btn?.classList.add('is-loading');
    btn?.setAttribute('disabled', 'disabled');

    try {
      const res = await fetch(`/cart/add.js?ts=${Date.now()}`, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form),
        credentials: 'same-origin'
      });
      if (!res.ok) throw await res.json();
      await res.json();
      openDrawer();
      const cart = (await refreshDrawer()) || (await getCartJSON(true));
      await syncMilestoneRewards(cart);
    } catch (err) {
      console.error('[AddToCart] ERROR:', err);
      alert(err?.description || 'Could not add to cart.');
    } finally {
      if (label?.dataset.originalText) {
        label.textContent = label.dataset.originalText;
        delete label.dataset.originalText;
      }
      btn?.classList.remove('is-loading');
      btn?.removeAttribute('disabled');
    }
  });
})();


/* ====================================================== */
/* PRODUCT PAGE ADD-TO-CART HANDLER                        */
/* ====================================================== */
(function () {
  if (window.__productAddBound) return;
  window.__productAddBound = true;
  document.addEventListener('submit', async (ev) => {
    const form = ev.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    ev.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    const label = btn?.querySelector('span');
    const prevText = label?.textContent;
    if (label) label.textContent = 'Adding…';
    btn?.classList.add('is-loading');
    btn?.setAttribute('disabled', 'disabled');

    try {
      const res = await fetch(`/cart/add.js?ts=${Date.now()}`, {
        method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form), credentials: 'same-origin'
      });
      if (!res.ok) throw await res.json();
      await res.json();
      document.querySelector('cart-drawer')?.classList.add('active');
      document.body.classList.add('overflow-hidden');
      const cart = (await refreshDrawer()) || (await getCartJSON(true));
      await syncMilestoneRewards(cart);
    } catch (err) {
      console.error('[ProductAdd] ERROR:', err);
      alert(err?.description || 'Could not add to cart.');
    } finally {
      if (label && prevText) label.textContent = prevText;
      btn?.classList.remove('is-loading');
      btn?.removeAttribute('disabled');
    }
  });
})();


/* ====================================================== */
/* SHIPPING PROTECTION                                     */
/* ====================================================== */
async function setShippingProtection(vid, on) {
  const res = await fetch(`/cart/update.js?ts=${Date.now()}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ updates: { [vid]: on ? 1 : 0 } })
  });
  if (!res.ok) throw await res.json();
  const cart = await res.json();
  CART_LAST_JSON = cart;
  CART_LAST_TS = Date.now();
  return cart;
}

(() => {
  const root = () => document.getElementById('shipping-protection');
  if (!root()) return;

  const SP_VARIANT_ID = (root().dataset.variantId || '').trim() || null;
  const SP_PRODUCT_HANDLE = (root().dataset.productHandle || '').trim() || null;
  let VARIANT_ID = null;

  const money = (cents) => {
    try {
      return Shopify.formatMoney(cents, (window.SHOP?.moneyFormat) || "${{amount}}");
    } catch {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.SHOP?.currency || 'AUD' });
    }
  };

  const btn = () => root()?.querySelector('.sp-toggle');
  const priceEl = () => root()?.querySelector('[data-sp-price]');

  async function resolveVariantId() {
    if (VARIANT_ID) return VARIANT_ID;
    if (SP_VARIANT_ID) return (VARIANT_ID = String(SP_VARIANT_ID));
    if (SP_PRODUCT_HANDLE) {
      const res = await fetch(`/products/${encodeURIComponent(SP_PRODUCT_HANDLE)}.js`, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Failed to load SP product');
      const p = await res.json();
      const v0 = p.variants?.[0];
      if (!v0) throw new Error('No SP variants');
      VARIANT_ID = String(v0.id);
      if (priceEl()) priceEl().textContent = money(v0.price);
      return VARIANT_ID;
    }
    throw new Error('SP requires data-variant-id or data-product-handle');
  }

  function setPressed(on) {
    const b = btn();
    if (!b) return;
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    const t = b.querySelector('.sp-toggle-text');
    if (t) t.textContent = on ? 'ON' : 'OFF';
    b.disabled = false;
    b.classList.remove('is-disabled');
  }

  let busy = false;
  async function onToggle() {
    if (busy || window.__spAdding) return;
    const b = btn();
    if (!b) return;
    busy = true;
    window.__spAdding = true;
    b.disabled = true;
    const wantOn = b.getAttribute('aria-pressed') !== 'true';
    try {
      const vid = await resolveVariantId();
      if (wantOn && !hasPaidItem(await getCartJSON(true))) {
        setPressed(false);
        return;
      }
      await setShippingProtection(vid, wantOn);
      if (!wantOn) sessionSet('sp_auto_added', 'true');
      setPressed(wantOn);
      await refreshDrawer();
      setPressed(wantOn);
    } catch {
      setPressed(!wantOn);
    } finally {
      const b2 = btn();
      if (b2) b2.disabled = false;
      window.__spAdding = false;
      busy = false;
    }
  }

  /* Expose so syncShippingProtectionToggle can rebind after footer replace */
  window.__spToggleHandler = onToggle;

  function reattach() {
    const b = btn();
    if (!b || b.__spBound) return;
    b.addEventListener('click', onToggle);
    b.__spBound = true;
  }

  async function init() {
    try {
      const vid = await resolveVariantId();
      const cart = await getCartJSON(true);
      setPressed(cart.items.some(it => String(it.variant_id) === String(vid)));
      root().hidden = false;
    } catch {
      root().hidden = true;
    }
    reattach();
  }

  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, async () => {
      reattach();
      try {
        const vid = await resolveVariantId();
        const cart = await getCartJSON(true);
        setPressed(cart.items.some(it => String(it.variant_id) === String(vid)));
      } catch {}
    });
  }

  init();
})();

/* Sync SP toggle state (called from refreshDrawer) */
function syncShippingProtectionToggle() {
  const spEl = document.getElementById('shipping-protection');
  if (!spEl) return;
  const vid = spEl.dataset.variantId;
  if (!vid) return;

  spEl.hidden = false;

  const b = spEl.querySelector('.sp-toggle');
  const label = b?.querySelector('.sp-toggle-text');
  if (!b) return;

  if (!b.__spBound && typeof window.__spToggleHandler === 'function') {
    b.addEventListener('click', window.__spToggleHandler);
    b.__spBound = true;
  }

  if (window.__spAdding) return;

  getCartJSON(true).then(async cart => {
    const hasSP = cart.items.some(it => String(it.variant_id) === String(vid));
    const canAutoAdd = !hasSP && hasPaidItem(cart) && sessionGet('sp_auto_added') !== 'true' && !window.__spAdding;

    if (canAutoAdd) {
      window.__spAdding = true;
      try {
        await setShippingProtection(vid, true);
        sessionSet('sp_auto_added', 'true');
        window.__spAdding = false;
        await refreshDrawer();
        return;
      } catch (err) {
        console.warn('[shipping protection] auto add error', err);
      } finally {
        window.__spAdding = false;
      }
    }

    b.setAttribute('aria-pressed', hasSP ? 'true' : 'false');
    b.classList.remove('is-disabled');
    if (label) label.textContent = hasSP ? 'ON' : 'OFF';
  }).catch(() => {});
}


/* ====================================================== */
/* PAGE LOAD INIT                                          */
/* ====================================================== */
async function initCartOnLoad() {
  try {
    const cart = await getCartJSON(true);
    updateMilestones(cart);
    applyGwpLines();
    await syncMilestoneRewards(cart);
  } catch {}
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCartOnLoad);
else initCartOnLoad();

/* Subscribe to cart updates for milestone refresh */
if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
  window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (e) => {
    if (e?.source === 'drawer-refresh' || e?.source === 'cart-items') return;
    getCartJSON(true).then(cart => updateMilestones(cart)).catch(() => {});
  });
}


/* ====================================================== */
/* CHECKOUT GUARD (cart JSON based, never dead-ends)       */
/* ====================================================== */
function getRestrictionIssues(cart) {
  const spId = getSpVariantId();
  const items = cart?.items || [];
  const issues = [];

  if (!hasPaidItem(cart, spId)) {
    items.forEach(it => issues.push({ reason: 'no-paid-item', variantId: it.variant_id, key: it.key, title: it.title, quantity: it.quantity }));
    return issues;
  }

  const lockedIds = [...new Set([...getLockedVariantIds(cart), ...(spId ? [spId] : [])])];
  const seen = new Set();
  items.forEach(it => {
    if (!lockedIds.includes(it.variant_id)) return;
    const duplicate = seen.has(it.variant_id);
    seen.add(it.variant_id);
    if (duplicate || it.quantity > 1) {
      issues.push({ reason: 'limit-one', variantId: it.variant_id, key: it.key, title: it.title, quantity: it.quantity });
    }
  });
  return issues;
}

async function proceedToCheckout() {
  console.log('[checkout] proceedToCheckout called', window.__checkoutState());
  if (window.__checkoutProceeding) {
    console.warn('[checkout] already proceeding, click ignored');
    return;
  }
  window.__checkoutProceeding = true;
  const checkoutUrl = `${(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/')}checkout`;

  try {
    let waited = 0;
    for (; (window.rewardSyncLock || window.__spAdding) && waited < 50; waited++) await new Promise(r => setTimeout(r, 100));
    if (waited) console.log(`[checkout] waited ${waited * 100}ms for reward sync`, { stillLocked: window.rewardSyncLock });

    let cart = await getCartJSON(true);
    console.log('[checkout] cart', cart.items.map(it => ({
      variantId: it.variant_id,
      title: it.title,
      qty: it.quantity,
      price: it.price,
      finalLine: it.final_line_price,
      key: it.key
    })));

    const issues = getRestrictionIssues(cart);
    console.log('[checkout] restriction issues', issues, { lockedIds: getLockedVariantIds(cart) });
    if (issues.length) {
      logCheckoutBlocked('Cart breaks free gift or shipping protection rules, correcting', { lines: issues });
      await syncMilestoneRewards(cart);
      cart = await getCartJSON(true);
      const remaining = getRestrictionIssues(cart);
      if (remaining.length || !hasPaidItem(cart)) {
        logCheckoutBlocked('Cart could not be corrected or has no paid items, checkout stopped', { lines: remaining });
        return;
      }
    }

    console.log('[checkout] redirecting to', checkoutUrl);
    location.href = checkoutUrl;
  } catch (err) {
    logCheckoutBlocked('Checkout check failed, continuing to checkout', { err });
    location.href = checkoutUrl;
  } finally {
    window.__checkoutProceeding = false;
  }
}

/* ====================================================== */
/* CART RULES ENFORCEMENT                                  */
/* ====================================================== */
const CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
let __rulesTimer = null;

function scheduleCartRulesSync(delay = 350) {
  clearTimeout(__rulesTimer);
  __rulesTimer = setTimeout(async () => {
    if (window.rewardSyncLock || window.__spAdding || cartUpdateInflight) {
      scheduleCartRulesSync(300);
      return;
    }
    try {
      const cart = await getCartJSON(true);
      if (getRestrictionIssues(cart).length) await syncMilestoneRewards(cart);
    } catch {}
  }, delay);
}

(() => {
  if (window.__cartRulesWatch) return;
  window.__cartRulesWatch = true;

  const isCartMutation = (url) => {
    try { return CART_MUTATION_RE.test(new URL(String(url), location.href).pathname); } catch { return false; }
  };

  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input?.url;
    const result = nativeFetch.apply(this, arguments);
    if (url && isCartMutation(url)) result.then(() => scheduleCartRulesSync(), () => {});
    return result;
  };

  const nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartMutation(url)) this.addEventListener('loadend', () => scheduleCartRulesSync());
    return nativeOpen.apply(this, arguments);
  };

  window.addEventListener('pageshow', () => scheduleCartRulesSync(0));
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') scheduleCartRulesSync(0);
  });
})();

function isCheckoutPath(url) {
  try { return /\/checkouts?(\/|$)/.test(new URL(url, location.href).pathname); } catch { return false; }
}

function isCheckoutSubmit(form, submitter) {
  if (!form || submitter?.name === 'update') return false;
  if (submitter?.name === 'checkout') return true;
  if (isCheckoutPath(form.getAttribute('action') || '')) return true;
  const isCartForm = /\/cart\/?$/.test(new URL(form.getAttribute('action') || location.href, location.href).pathname);
  return isCartForm && !!form.querySelector('[name="checkout"]');
}

function cartLooksInvalid() {
  return !!CART_LAST_JSON && getRestrictionIssues(CART_LAST_JSON).length > 0;
}

function isFreeVariantForm(el) {
  const form = el.closest('form[action*="/cart/add"]') || el.closest('product-form')?.querySelector('form');
  const id = parseInt(form?.querySelector('[name="id"]')?.value || '0', 10);
  return !!id && getLockedVariantIds().includes(id);
}

document.addEventListener('submit', (e) => {
  if (!isCheckoutSubmit(e.target, e.submitter)) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  proceedToCheckout();
}, true);

document.addEventListener('click', (e) => {
  const link = e.target.closest?.('a[href]');
  if (link && isCheckoutPath(link.href)) {
    e.preventDefault();
    e.stopImmediatePropagation();
    proceedToCheckout();
    return;
  }

  const express = e.target.closest?.('.shopify-payment-button, shopify-buy-it-now-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .additional-checkout-buttons, .cart__dynamic-checkout-buttons');
  if (!express) return;

  const inCart = !!express.closest('cart-drawer, #CartDrawer, #main-cart-footer, cart-items, .cart__footer');
  const blocked = inCart
    ? (cartLooksInvalid() || window.rewardSyncLock || window.__spAdding || checkoutLockCount > 0)
    : isFreeVariantForm(express);

  if (blocked) {
    e.preventDefault();
    e.stopImmediatePropagation();
    logCheckoutBlocked('Express checkout blocked, cart breaks rules', { inCart });
    if (inCart) getCartJSON(true).then(syncMilestoneRewards).catch(() => {});
  }
}, true);

/* Expose for external scripts (bundle widget, product pages, etc) */
window.refreshDrawer = refreshDrawer;
window.syncMilestoneRewards = syncMilestoneRewards;
window.getCartJSON = getCartJSON;
window.proceedToCheckout = proceedToCheckout;

} /* end __CART_JS_LOADED__ guard */